<script setup lang="ts">
import axios from 'axios'
import AuthContainer from './components/AuthContainer.vue'
import AuthForm from './components/AuthForm.vue'
import type { AuthFormData } from '../../types/types'
import useSessionStorage from '@/composables/sessionStorage'

const notification = useNotification()
const isLoaded = ref(true)
const isResetLinkSent = ref(false)
const LOGO = '/images/logo_hp_dark.svg'
const { t } = useI18n()
const { forgotPasswordEmail } = useSessionStorage()

const handleSubmit = async (data: AuthFormData) => {
  if (!isLoaded.value) {
    return
  }
  forgotPasswordEmail.value = data.email
  isLoaded.value = false
  try {
    await axios.post('/auth/password-token', {
      email: forgotPasswordEmail.value
    })
    if (isResetLinkSent.value) {
      notification.create('success', {
        text: t('login.forgot.success'),
        timeout: 5000
      })
    }
    isResetLinkSent.value = true
  } catch {
    notification.create('error', {
      text: t('login.forgot.error'),
      timeout: 5000
    })
  } finally {
    isLoaded.value = true
  }
}
</script>

<template>
  <AuthContainer
    v-if="!isResetLinkSent"
    :title="t('login.forgot.title')"
    :subtitle="t('login.forgot.subtitle')"
    should-show-redirect-to-login-link
  >
    <AuthForm :is-loaded="isLoaded" page-type="ForgotPassword" @on-submit="handleSubmit"></AuthForm>
  </AuthContainer>
  <div v-else class="text-center">
    <div class="lg:max-h-2xl mx-auto w-screen max-w-xl overflow-y-auto px-4 py-6 sm:px-6 lg:px-12">
      <img class="mx-auto h-10 w-auto" :src="LOGO" alt="Pongo" />
    </div>
    <h2 class="mb-4 mt-3 font-bold text-foreground">{{ t('login.forgot.text.title') }}</h2>
    <div class="text-sm text-muted-foreground">
      <p class="mb-3">
        {{ t('login.forgot.text.first') }}
      </p>
      <p class="mb-3 font-semibold">
        {{ forgotPasswordEmail }}
      </p>
      <p>
        {{ t('login.forgot.text.second') }}
        <a
          href="#"
          class="font-semibold text-primary hover:text-primary/80"
          @click="handleSubmit({ email: forgotPasswordEmail })"
          >{{ t('login.forgot.text.sendLink') }}</a
        >
      </p>
    </div>
  </div>
</template>
